const typographyTimeActions = {
  timelineTitle: 'Timeline',
  adminWarning: 'Admins can edit information, add files, comments, and complete/cancel actions',
  analystWarning: 'Analysts can add files, comments, and complete/cancel in any action, and edit information of the actions they created',
  contractorWarning: 'Contractors can add files, comments, and complete/cancel the actions they are responsible for'
};

export default typographyTimeActions;
